import type { CancelSubscription200Data } from './cancelSubscription200Data';

/**
 * 공통 API 응답 형식
 */
export type CancelSubscription200 = {
  /**
   * 응답 데이터
   * @nullable
   */
  data?: CancelSubscription200Data;
  /** 응답 메시지 */
  message: string;
  /** 요청 성공 여부 */
  success: boolean;
  /** 응답 시간 */
  timestamp?: string;
};
